module.exports = __webpack_public_path__ + "img/RS-PPE-ICONS-INFO.4146cb68.svg";